import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { ConfirmDialog } from '../../../common/ConfirmDialog'
import { TSCanDto } from '../../../../core/dto/device/ts-cans/ts-can.dto'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const TSCanRemoveCredentialsButton = () => {
  const { record: tsCan, loading } = useShowContext<TSCanDto>()
  const classes = useStyles()
  const [
    removeTSCanCredentialsDialogOpen,
    setRemoveTSCanCredentialsDialogOpen,
  ] = useState(false)
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()
  const notify = useNotify()

  const handleRemoveTSCanCredentials = async () => {
    setRemoveTSCanCredentialsDialogOpen(false)
    await mutate(
      {
        type: sanitizeFetchType('removeTSCanCredentials'),
        resource: ResourceName.TS_CANS,
        payload: {
          tsCanId: tsCan?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refresh()
  }

  const handleRemoveTSCanCredentialsDialog = () => {
    setRemoveTSCanCredentialsDialogOpen(true)
  }

  return (
    <>
      <ConfirmDialog
        open={removeTSCanCredentialsDialogOpen}
        confirm={handleRemoveTSCanCredentials}
        source="setTSCanCredentials"
        cancel={() => setRemoveTSCanCredentialsDialogOpen(false)}
        action="remove"
        resource={ResourceName.TS_CANS}
      />
      <Button
        variant="contained"
        onClick={handleRemoveTSCanCredentialsDialog}
        color="primary"
        className={classes.button}
        label="resources.ts-cans.actions.removeCredentials"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.TS_CANS_MANAGE_CREDENTIALS) ||
          loading ||
          mutationLoading
        }
      />
    </>
  )
}
